import React, { createContext, useContext } from 'react';

const StudyRuntimeContext = createContext(null);

export function StudyRuntimeProvider({ value, children }) {
  return (
    <StudyRuntimeContext.Provider value={value}>
      {children}
    </StudyRuntimeContext.Provider>
  );
}

export function useStudyRuntime() {
  return useContext(StudyRuntimeContext);
}
